<section class="row mb-4 pl-2 border-left">
  <section class="col-sm-12 col-md-12 mb-4 mt-4">
    <h2 class="h6 font-weight-bold mb-2">Validación Fontur</h2>
    <div class="row">
      <ul class="list-group col-sm-12 col-md-6">
        <li class="list-group-item small d-flex justify-content-between">
          <label class="pr-3">Fecha y Hora de la consulta</label>
          <label>{{informacionEstablecimiento.fecha_validacion_fontur | date:'d/MMM/yyyy, h:mm a'}}</label>
        </li>
        <!-- <li class="list-group-item small d-flex justify-content-between">
          <label class="pr-3">Pasa Fontur</label>
          <label>{{validacionFontur === 1 ? 'Error de comunicación con FONTUR' :
            (validacionFontur === 0 ? 'Si' : 'No')}}</label>
          <button class="btn btn-outline-primary" (click)="reValidarFontur()"
            *ngIf="authService.getRolUser(tipo_funcionario)">Reintentar</button>
        </li> -->
        <li class="list-group-item small d-flex justify-content-between">
          <label class="pr-3">Mensaje</label>
          <label>{{reditarMensaje(informacionEstablecimiento.respuesta_validacion_fontur)}}</label>
        </li>
      </ul>
    </div>
  </section>
</section>
